import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import parse, { domToReact } from "html-react-parser";
import { ApplicationState } from "../../../store";
import { IPackage, IPackageProduct } from "../../../store/protectionPlanService/idf/types";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    closeDialog: any;
    showUpgradeDialog: any;
    packageIndex: number;
}

const IDFProtectionPlanUpgradeConfirmation: React.FunctionComponent<IProps> = (props) => {
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanIdfState && state.protectionPlanIdfState.protectionPlanData) {
            return state.protectionPlanIdfState.protectionPlanData.packageList;
        }
    });

    const currentPackage = packageList?.find((pkg) => pkg.IsActive);
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;

    const showPackageUpgradeDialog = () => {
        props.showUpgradeDialog();
    };

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const displayProduct = (product: IPackageProduct, index: number) => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            return (
                <li key={"product_" + index}>
                    <em className="las la-check-circle inline-icon status-good"></em>
                    <span> {parse(product.productName!)}</span>
                </li>
            );
        } else {
            return (
                <li key={"product_" + index}>
                    <em className="las la-minus-circle inline-icon status-bad"></em>
                    <span> {parse(product.productName!)} </span>
                </li>
            );
        }
    };

    const displayConfirmationMessage = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            if (selectedPackage?.productDifference.length < 1) {
                return (
                    <p>
                        This will upgrade your plan from {currentPackage?.name} to {selectedPackage?.name}.
                    </p>
                );
            } else {
                return (
                    <p>
                        By upgrading from {currentPackage?.name} Plan to {selectedPackage?.name} Plan, the following identity protection services will be added to
                        your account:
                    </p>
                );
            }
        } else {
            return <p>By canceling your subscription the following identity protection services will no longer be available to you.</p>;
        }
    };

    const dialogTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            return "Confirm Upgrade";
        } else {
            return "Confirm Cancelation";
        }
    };

    const confirmButtonTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            return "Continue with Upgrade";
        } else {
            return "Continue with Cancelation";
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="coins" />
                </div>
                <h1>{dialogTitle()}</h1>
            </div>

            <div className="dialog-body large-dialog-scroll">
                {displayConfirmationMessage()}

                <ul className="list-reset">
                    {selectedPackage?.productDifference &&
                        selectedPackage.productDifference?.map((product, index: number) => displayProduct(product as IPackageProduct, index))}
                </ul>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            id="btn-cancel-upgrade-confirmation"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Close confirmation" });
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-submit-upgrade-confirmation"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Continue " + selectedPackage.ActionButtonText?.toUpperCase() });
                                showPackageUpgradeDialog();
                            }}
                        >
                            <span className="btn-text">{confirmButtonTitle()}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default IDFProtectionPlanUpgradeConfirmation;
